import {Pipe, PipeTransform} from '@angular/core';

import {DeviceType} from '../../afb-api/enums/device-type.enum'

@Pipe({
  name: 'deviceTypeName'
})
export class DeviceTypeNamePipe implements PipeTransform {
  DeviceType = DeviceType;

  transform(value: DeviceType): any {
    return this.DeviceType[value];
  }
}
